import { ComponentProps } from 'react';
import { useIntl } from 'react-intl';
import type CardLocation from '@alltrails/amplitude/enums/CardLocation';
import IconButton from '@alltrails/denali/components/IconButton';
import Calendar from '@alltrails/denali/icons/Calendar';
import useCreateEventCta from '../../hooks/useCreateEventCta';
import type { EventMapType } from '../../types';

type CreateEventButtonProps = Pick<ComponentProps<typeof IconButton>, 'elevated' | 'size' | 'variant'> & {
  entryPoint?: CardLocation;
  mapId: number;
  mapType: EventMapType;
};

const CreateEventIconButton = ({ entryPoint, mapId, mapType, ...iconButtonProps }: CreateEventButtonProps) => {
  const intl = useIntl();
  const { modals, onClick } = useCreateEventCta({ entryPoint, mapId, mapType });

  return (
    <>
      <IconButton
        {...iconButtonProps}
        icon={{ Component: Calendar }}
        onClick={onClick}
        title={intl.formatMessage({ defaultMessage: 'Create invite' })}
      />
      {modals}
    </>
  );
};

export default CreateEventIconButton;
